import React from "react";
import { MuiTelInput, MuiTelInputProps } from "mui-tel-input";
import { Typography, styled } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Index";

const FieldLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "textcolor",
})<{ textcolor?: string }>(({ textcolor }) => ({
  fontSize: "12px",
  fontWeight: 600,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  color: textcolor,
  marginBottom: "6px",
  opacity: 0.7,

  "& span.required": {
    color: "#ff4d4f",
    marginLeft: "2px",
  },
}));

export type PillPhoneNumberFieldProps = MuiTelInputProps & {
  label?: string;
  required?: boolean;
  inputbg?: string;
  textcolor?: string;
  placeholdercolor?: string;
  labelColor?: string;
};

const PillPhoneNumberField: React.FC<PillPhoneNumberFieldProps> = ({
  label,
  required,
  inputbg,
  textcolor,
  placeholdercolor,
  labelColor,
  sx,
  defaultCountry = "ZW",
  ...props
}) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);
  const color100 = reduxTheme.primary_colors?.[100];
  const color700 = reduxTheme.primary_colors?.[700];
  const color800 = reduxTheme.primary_colors?.[800];
  const color300 = reduxTheme.primary_colors?.[300];

  return (
    <>
      {label && (
        <FieldLabel textcolor={labelColor ?? color100}>
          {label}
          {required && <span className="required">*</span>}
        </FieldLabel>
      )}
      <MuiTelInput
        fullWidth
        defaultCountry={defaultCountry}
        sx={{
          width: "100%",
          "& .MuiOutlinedInput-root": {
            backgroundColor: inputbg ?? color800,
            borderRadius: "12px",
            "& fieldset": { border: "none" },
            "&:hover fieldset": { border: "none" },
          },
          "& .MuiOutlinedInput-input": {
            padding: "11px 14px",
            fontSize: "13px",
            color: textcolor ?? color700,
            "&::placeholder": {
              color: placeholdercolor ?? color300,
              opacity: 0.9,
            },
          },
          "& .MuiTelInput-Flag": { ml: "12px" },
          ...sx,
        }}
        {...props}
      />
    </>
  );
};

export default PillPhoneNumberField;
